export default __webpack_public_path__ + "static/media/pay.060d13c1.png";